<template>
    <div class="admin-withdraw">
        <WithdrawRequestList :withdraw_request_id="withdraw_request_id"/>
    </div>
</template>

<script>
// @ is an alias to /src
import WithdrawRequestList from "@/components/WithdrawRequestList";

export default {
    name: "AdminWithdraw",
    components: {
        WithdrawRequestList,
    },
    props:{
        withdraw_request_id: {type: String, default: null}
    },
    data() {
        return {
            activeTab: "WTD_REQ",
        };
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    }
};
</script>
<style scoped>
</style>